<template>
  <div class="kashira-item-list">
    <v-kashira-item
        @element-click="$emit('element-click2', $event, item)"
      v-for="(item, index) in faceGroupItems"
      :item="item"
      :key="item.id"
      :imgHeight="imgHeight"
      @height="imgHeightCalc($event, index)"/>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  props: {
    item: Object,
  },
  computed: {
    ...mapState({
      faceGroupItems(state) {

        return this.item.face_group_product;
        let val = this.item.face_group_product
        let sorted = {}
        let array = []

        Object.keys(val).forEach((key) => {
          if (val.hasOwnProperty(key)) {
            array.push(key)
          }
        })

        // array.sort((a, b) => {
        //   a = Number(val[a].page.order.replace('-', '.'))
        //   b = Number(val[b].page.order.replace('-', '.'))
        //
        //   if (a > b){
        //     return -1
        //   } else if (a < b){
        //     return 1
        //   }
        //   return 0
        // })
        //
        // for (let i=0; i<array.length; i++) {
        //   sorted[array[i]] = val[array[i]]
        // }
        //
        // console.log('sorted');
        // console.log(sorted);

        return sorted
      },
      windowWidth: state => state.window.width,
    }),
  },
  components: {
    'v-kashira-item': require('@/components/kashira-item.vue').default,
  },
  data() {
    return {
      imgHeight: {},
    }
  },
  methods: {
    imgHeightCalc(val, index) {
      let num = Number(index)
      let target1, target2
      this.$set(this.imgHeight, num, val)

      // 2カラム
      if (this.$route.meta.sidebar || 992 < this.windowWidth >= 768) {
        if ((num % 2) === 0) {
          target1 = num + 1
        } else {
          target1 = num - 1
        }

        if (this.imgHeight[target1]) {
          if (this.imgHeight[num] >= this.imgHeight[target1]) {
            this.$set(this.imgHeight, target1, this.imgHeight[num])
          } else {
            this.$set(this.imgHeight, num, this.imgHeight[target1])
          }
        }
      }
    },
    routeChange() {
      this.imgHeight = {}
    },
  }
}
</script>



<style lang="scss">
.kashira-item-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 28px;
}
</style>
